<template>
    <!-- team area start -->
    <div class="team-area bg-blue pd-top-115 pd-bottom-90">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-6">
                    <div class="section-title style-white text-center">
                        <h5 class="sub-title double-line">Expert Team</h5>
                        <h2 class="title">Meet with our expert</h2>
                        <p class="content">Meet the Expert sessions are an opportunity for delegates to sit down and converse on a more one-to-one level with the experts in their field. </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-3 col-md-6">
                    <div class="single-team-inner style-2 text-center">
                        <div class="thumb">
                            <img src="assets/img/team/profil_christel.jpg" alt="img">
                        </div>
                        <div class="details-wrap">
                            <div class="details-inner">
                                <h4><a href="team-details.html">NGUESSOP Christel</a></h4>
                                <p>Software developer</p>
                                <ul class="social-media mt-3 mb-2">
                                    <li>
                                        <a class="facebook" href="#">
                                            <i class="fab fa-facebook-f"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="twitter" href="#">
                                            <i class="fab fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="instagram" href="#">
                                            <i class="fab fa-instagram"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="youtube" href="#">
                                            <i class="fab fa-youtube"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="single-team-inner style-2 text-center">
                        <div class="thumb">
                            <img src="assets/img/team/Profil_Nadine.jpg" alt="img">
                        </div>
                        <div class="details-wrap">
                            <div class="details-inner">
                                <h4><a href="team-details.html">Nadine</a></h4>
                                <p>Expert PLM</p>
                                <ul class="social-media mt-3 mb-2">
                                    <li>
                                        <a class="facebook" href="#">
                                            <i class="fab fa-facebook-f"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="twitter" href="#">
                                            <i class="fab fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="instagram" href="#">
                                            <i class="fab fa-instagram"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="youtube" href="#">
                                            <i class="fab fa-youtube"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="single-team-inner style-2 text-center">
                        <div class="thumb">
                            <img src="assets/img/team/3.webp" alt="img">
                        </div>
                        <div class="details-wrap">
                            <div class="details-inner">
                                <h4><a href="team-details.html">Mme OUAMBO Sabine</a></h4>
                                <p>Director</p>
                                <ul class="social-media mt-3 mb-2">
                                    <li>
                                        <a class="facebook" href="#">
                                            <i class="fab fa-facebook-f"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="twitter" href="#">
                                            <i class="fab fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="instagram" href="#">
                                            <i class="fab fa-instagram"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="youtube" href="#">
                                            <i class="fab fa-youtube"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6">
                    <div class="single-team-inner style-2 text-center">
                        <div class="thumb">
                            <img src="assets/img/team/4.webp" alt="img">
                        </div>
                        <div class="details-wrap">
                            <div class="details-inner">
                                <h4><a href="team-details.html">Karshin Kumar</a></h4>
                                <p>Founder</p>
                                <ul class="social-media mt-3 mb-2">
                                    <li>
                                        <a class="facebook" href="#">
                                            <i class="fab fa-facebook-f"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="twitter" href="#">
                                            <i class="fab fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="instagram" href="#">
                                            <i class="fab fa-instagram"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a class="youtube" href="#">
                                            <i class="fab fa-youtube"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- team area end -->
</template>
<script>
    export default {
        name: "Team"
    }
</script>